///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.unsolicited = abcsetup.consumer_rfp.unsolicited || {};
abcsetup.consumer_rfp.unsolicited.show = abcsetup.consumer_rfp.unsolicited.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.unsolicited.show = {
    /**
     *
     */
    init: function () {

        abcsetup.setTitle('Unsolicited Bid');

         // Init the common lib
         abcsetup.consumer_rfp.unsolicited.common.init();
    },

    fieldError: function() {
        var errorField = $('form').find('.invalid').first();
        //alert(errorField.parent().html());
        //abcsetup.unblockUI();
    }
}